import api from '@/libs/axios'
import store from '../index'
import useAPI from '../../utils/useAPI'
import i18n from '../../libs/i18n'
import qs from 'qs'

const translateTerms = (paymentMethods) => {
  paymentMethods.forEach(pm => pm.name = i18n.t(pm.name))
}

export default {
  getPaymentMethods ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.paymentMethods.length == 0) {
        api.get('/paymentMethods')
          .then(response => {
            commit('SET_PAYMENTMETHODS', response.data)
            resolve(response)
          })
          .catch(err => {
            console.log('Error', err)
            reject(err)
          })
      } else {
        resolve(true)
      }
    })
  },
  getAutocompletePaymentMethods ({ commit, state }, payload) {
    // const { performApiCall } = useAPI()
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      // if (payload.kanbanSortBy == null) {
      //   commit('SET_ISKANBANUSERLIST', false)
      // } else {
      //   commit('SET_ISKANBANUSERLIST', true)
      // }

      api.get('/autocomplete/paymentMethods' + '?' + qs.stringify(payload))
        .then(response => {
          // console.log(response)
          commit('SET_AUTOCOMPLETEPAYMENTMETHODS', response.data.results)
          store.commit('app/TOGGLE_LOADING', false)

          resolve(response.data)
        })
        .catch(err => {
          console.log('Error', err)
          // reject(err)
        })
    })

  },

}